import type { DataCollectionStatement } from '../../types/apiModels'
import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection, unwrapVoid } from '../ruutsApi/normalize'

async function getByFarmYear(
  farmId: string,
  year: string | number,
  userRole: string,
  signal?: AbortSignal,
): Promise<DataCollectionStatement | null> {
  const response = await apiClient.get(endpoints.dataCollectionStatements, {
    params: { farmId, year, userRole },
    signal,
  })
  return unwrapCollection<DataCollectionStatement>(response)[0] ?? null
}

async function getByFarmId(
  farmId: string,
  userRole: string,
  signal?: AbortSignal,
): Promise<DataCollectionStatement[]> {
  const response = await apiClient.get(endpoints.dataCollectionStatements, {
    params: { farmId, userRole },
    signal,
  })
  return unwrapCollection<DataCollectionStatement>(response)
}

async function sendReview(dcsId: string, userRole: string): Promise<void> {
  const response = await apiClient.put(
    `${endpoints.dataCollectionStatements}/review/send/${dcsId}`,
    { userRole },
  )
  return unwrapVoid(response)
}

async function startReview(dcsId: string, userRole: string): Promise<void> {
  const response = await apiClient.put(
    `${endpoints.dataCollectionStatements}/review/start/${dcsId}`,
    { userRole },
  )
  return unwrapVoid(response)
}

async function approve(dcsId: string): Promise<void> {
  const response = await apiClient.put(`${endpoints.dataCollectionStatements}/approve/${dcsId}`, {})
  return unwrapVoid(response)
}

async function changeOwnership(dcsId: string, userRole: string): Promise<void> {
  const response = await apiClient.put(
    `${endpoints.dataCollectionStatements}/ownership/change/${dcsId}`,
    { userRole },
  )
  return unwrapVoid(response)
}

export const dataCollectionStatementService = {
  getByFarmYear,
  getByFarmId,
  sendReview,
  startReview,
  changeOwnership,
  approve,
}
